// extracted by mini-css-extract-plugin
export var compact = "RXDMJ";
export var copilotResultsTable = "u2Z6r";
export var customHeaderText = "vlQVl";
export var customHeaderTextNoMarginBottom = "BWyDy";
export var customHeaderTextWithFavorite = "jXaVF";
export var customSelectionContainer = "PhBV4";
export var customSelectionContainerNoSenderImage = "U3hya";
export var customTextContainer = "IG8s8";
export var favoriteIconCompact = "lVYdm";
export var favoriteIconDenseless = "tHvW_";
export var favoriteIconFull = "bi8ao";
export var favoriteIconMedium = "yJGzp";
export var folderTab = "NRwJb";
export var folderTabNotSelected = "iYSwP";
export var folderTabText = "PiuRP";
export var full = "P3G2l";
export var headerTabsContainer = "AvC2Y";
export var medium = "B7o5q";
export var showSelectionModeButtonMCL = "mCzau";
export var showSelectionModeButtonSCL = "a2Qhm";